<template>
  <div :class="siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? 'register-form-nuts' : 'register-form'">
    <template v-if="isOlakk">
      <i18n class="title" path="register.LAB_CLUB_INVITE_H5_WELCOME" tag="p">
        <template slot="club"> {{ club_name }}({{ club_id }})</template>
      </i18n>
    </template>
    <template v-else-if="!hiddenPortrait">
      <div class="original">
        <i18n class="title" path="register.LAB_CLUB_INVITE_H5_WELCOME" tag="p">
          <template slot="club">{{ siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? "Nuts Poker" : "KKPOKER" }}</template>
        </i18n>
        <template v-if="siteType.GetSiteType() !== siteType.SITE_TYPE_NUTS">
          <div class="portrait_name">
            <div class="photo_frame">
              <img :src="club_photo" style="width: 1.76rem"/>
            </div>
            <div style="font-size: 0.3rem; margin-left: 0.3rem">
              {{ club_name }}
            </div>
          </div>
          <i18n
            class="join"
            path="register.LAB_CLUB_INVITE_H5_WELCOME_LONG"
            tag="p"
          />
        </template>
      </div>
    </template>
    <div class="content">
      <div class="content_item">
        <van-field
          class="custom-input-usr"
          v-model.trim="username"
          :placeholder="$t('register.LAB_AUTH_EMAIL')"
          maxlength="60"
          @change="toValid('username')"
          autocomplete="off"
          autofocus="true"
          @focus="handleInput(1)"
          @blur="handleBlur(1)"
        />
        <div v-show="user_error" class="error">
          <p>{{ user_error }}</p>
        </div>
      </div>

      <div class="content_item content_pwd">
        <van-field
          class="custom-input-psd"
          v-model="password"
          :type="hide_password ? 'password' : 'text'"
          :placeholder="$t('register.LAB_PASSWORD')"
          @change="toValid('password')"
          autocomplete="off"
          autofocus="true"
          @focus="handleInput()"
          @blur="handleBlur()"
        />
        <img
          v-show="hide_password"
          @click="hide_password = !hide_password"
          class="password_img"
          src="/static/img/register/login_eye_n.png"
        />
        <img
          v-show="!hide_password"
          @click="hide_password = !hide_password"
          class="password_img"
          src="/static/img/register/login_eye_s.png"
        />
        <div v-show="pwd_error" class="error">
          <p>{{ pwd_error }}</p>
        </div>
      </div>

      <van-checkbox v-model="checked" id="termsCheck" :class = "pwd_error !=='' ? 'showTip':'' ">
        <i18n path="register.LAB_H5_CHECK_TIPS" tag="p">
          <a
            place="link1"
            :href="globalConfig.termsOfService"
            target="_blank"
          >
            {{ $t('register.LAB_CLUB_CHECK_TEMS2') }}
          </a>
          <a
            place="link2"
            :href="globalConfig.privacyPolicy"
            target="_blank"
          >
            {{ $t(globalConfig.LAB_CLUB_CHECK_TEMS4) }}
          </a>
          <a
            place="link3"
            :href="globalConfig.affiliateMarketing"
            target="_blank"
          >
            {{ $t('register.LAB_H5_Marketing_Programme') }}
          </a>
        </i18n>
        <template #icon="props">
          <img
            class="img-icon"
            :src="props.checked ? inactive_icon : active_icon"
          />
        </template>
      </van-checkbox>
      <div
        class="register_buttom"
        @click="toRegister"
      >
        <p>{{ $t('register.LAB_REGISTER_RIGHT_NOW') }}</p>
      </div>
    </div>

    <!-- TODO: i18n -->
    <van-dialog v-model="showCode" :title="$t('register.LAB_VERIFICATION')" :class="siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? 'code-dialog code-dialog-nuts' : 'code-dialog code-dialog-iom'" get-container="body"
                :show-confirm-button="false">
      <img v-if="siteType.GetSiteType() == siteType.SITE_TYPE_NUTS" class="close-btn" src="/static/img/register/btn_close_nuts.png" @click="showCode = false">
      <img v-else class="close-btn" src="/static/img/register/btn_close.png" @click="showCode = false">
      <div class="content">
        <div class="content_item">
          <span class="code_text">{{ $t('register.LAB_VERIFY_CODE_TIPS') }}</span>
          <div class="code_block">
            <img class="code_img" :src="code_src" @click="initRegisterCaptcha()"/>
            <van-field
              v-model.trim="code"
              maxlength="4"
              @change="toValid('code')"
            />
          </div>
          <div v-show="code_error" class="error">
            <p>{{ code_error }}</p>
          </div>
        </div>
        <div
          class="register_buttom"
          @click="toEmailVerification"
          :class="{ register_loading: register_load }"
        >
          <p>{{ $t('register.LAB_CONFIRM') }}</p>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  getRegisterCaptcha,
  sendRegister,
  getClubInfoByInvitaionCode,
  checkFingerprint,
  getMitIDLink
} from '@/api/official'
import md5 from 'js-md5'
import { getBackgroundImage } from '@/utils/backgroundImage'
import { toBury } from '../configs/userStatsTrack'
import { getErrorMsg } from '@/configs/register'
import { getFingerprint } from '../configs/userStatsTrack'
import siteType from '../configs/siteType'

export default {
  name: 'registerForm',
  props: {
    country: String,
    platform: String, // temporarily abandoned
    isOlakk: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showCode: false,
      hiddenPortrait: false,
      club_photo: '/static/img/register/1.png',
      club_name: '',
      club_id: '',
      user_id: 0,
      is_invitecode: false,
      username: '',
      password: '',
      code: '',
      checked: false,
      code_src: '',
      hide_password: true,
      user_error: '',
      pwd_error: '',
      code_error: '',
      active_icon: '/static/img/register/check_small_off.png',
      inactive_icon: siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? '/static/img/register/check_small_on_nuts.png' : '/static/img/register/check_small_on.png',
      register_load: false,
      siteType,
    }
  },
  created () {
    getFingerprint(this)
    this.initRegisterCaptcha()
    this.getClubInfoByInvitaionCode()
  },
  methods: {
    // wait invited code
    getClubInfoByInvitaionCode () {
      if (!this.$route.params.invitecode) {
        this.hiddenPortrait = true
        return
      }

      let resData = {}
      getClubInfoByInvitaionCode({
        invitecode: this.$route.params.invitecode,
        old: window.location.host === 'notice_kkpoker' ? 1 : 0
      })
        .then((res) => {
          if (res.code === 0) {
            this.club_name = res.name
            this.club_id = res.clubid
            this.user_id = res.uid || 0
            switch (res.icon.substring(0, 1)) {
              case 'h':
                this.club_photo = res.icon
                break
              default:
                this.club_photo =
                  '/static/img/register/' + res.icon.substring(0, 1) + '.png'
                break
            }
            this.is_invitecode = true
            resData = res
            // save is_invitecode, user_id, club_id in store.js
            this.$store.commit('SET_CLUB_INFO',  { invitecode: this.is_invitecode, userId: this.user_id, clubId: this.club_id})
          } else {
            this.hiddenPortrait = true
          }
        })
        .finally(() => {
          const images = getBackgroundImage(resData, this.country)
          this.$emit('setBackgroundImage', images)
          this.$emit('setIsInviteCode', this.is_invitecode)
          this.visitWeb(this.user_id, this.club_id)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    visitWeb (f4, clubId) {
      const buryType = !this.is_invitecode ? 'LinkAccess' : 'InviteLinkAccess'
      const f3 = !this.is_invitecode ? 1 : 2
      toBury(this, buryType, 801, 1, f3, f4, 0, this.$store.state.platform, clubId)
    },
    initRegisterCaptcha () {
      getRegisterCaptcha()
        .then((res) => {
          this.code_src = 'data:image/png;base64,' + res.content
          this.captchaKey = res.captchaKey
        })
        .catch((err) => {
          console.log(err)
        })
    },
    handleInput(value) {
      const inputClass = value ? '.custom-input-usr' : '.custom-input-psd';
      document.querySelector(inputClass).classList.add('not-empty');
    },
    handleBlur(value) {
      const inputClass = value ? '.custom-input-usr' : '.custom-input-psd';
      document.querySelector(inputClass).classList.remove('not-empty')
    },
    toValid (type) {
      if (type === 'username') {
        const userNameNoSpace = this.username.replace(/\s*/g, '')
        const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
        if (reg.test(userNameNoSpace)) {
          this.user_error = ''
          return true
        } else {
          this.user_error = this.$t('register.LAB_ACCOUNT_EMAIL_FORM_WRONG')
        }
      }
      if (type === 'password') {
        let inValidWord = ''
        let eachValid = false
        let oneLetter = false
        let oneNumber = false
        for (let i = 0; i < this.password.length; i++) {
          const asciiValue = this.password[i].charCodeAt(0)
          inValidWord = this.password[i]
          eachValid = false
          if (asciiValue >= 32 && asciiValue <= 126) {
            eachValid = true
            // 判斷不合規定的特殊符號
            switch (asciiValue) {
              case 32: // 空格
                inValidWord = 'Space'
              // eslint-disable-next-line no-fallthrough
              case 34: // 雙引號
              case 39: // 引號
              case 47: // 正斜槓
              case 92: // 反斜槓
                eachValid = false
                break
            }
          }
          if (!eachValid) {
            if (inValidWord !== 'Space') {
              this.pwd_error = this.$t('register.LAB_REGISTER_PASSWORD_TIP3', { word: inValidWord })
            } else {
              this.pwd_error = this.$t('register.LAB_REGISTER_PASSWORD_TIP4')
            }
            break
          }
        }
        for (let i = 0; i < this.password.length; i++) {
          const asciiValue = this.password[i].charCodeAt(0)
          inValidWord = this.password[i]
          if (asciiValue >= 48 && asciiValue <= 57) {
            oneNumber = true
          }
          if ((asciiValue >= 65 && asciiValue <= 90) || (asciiValue >= 97 && asciiValue <= 122)) {
            oneLetter = true
          }
        }
        const lengthValid = this.password.length >= 6 && this.password.length <= 16
        const atLeastOne = oneLetter && oneNumber
        if (!lengthValid || !atLeastOne) {
          this.pwd_error = this.$t('register.LAB_REGISTER_PASSWORD_TIP2')
        }
        if (eachValid && lengthValid && atLeastOne) {
          this.pwd_error = ''
          return true
        }
      }
      if (type === 'code') {
        const reg = /^[a-zA-Z0-9]{4,4}$/
        if (reg.test(this.code)) {
          this.code_error = ''
          return true
        } else {
          this.code_error = this.$t('register.LAB_VERIFICATION_CODE_ERROR')
        }
      }
      if (type === 'agreement') {
        if (this.checked) {
          return true
        } else {
          this.$toast({
            message: this.$t('register.LAB_CLUB_CHECK_TIPS'),
            className: 'register_toast'
          })
          return false
        }
      }
      return false
    },
    refresh () {
      // this.username = ''
      // this.password = ''
      this.code = ''
      this.initRegisterCaptcha()
    },
    judgeClient () {
      const u = navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      // if (isAndroid) {
      //   window.location.href = this.ANDROID_VERSION
      // } else if (isIOS) {
      //   window.location.href = this.APPLE_VERSION
      // } else {
      const countyMap = {
        pt: 'br',
        ru: 'ru',
        jp: 'jp',
        mn: 'mn',
        es: 'es'
      }[this.country]
      const subDomain = countyMap || 'www'
      let link = ''
      if (siteType.GetSiteType() == siteType.SITE_TYPE_NUTS) {
        link = 'https://nutspoker.cc'
      } else {
      if (this.$root.currentType === 'mannin') {
        link = subDomain === 'mn'
          ? 'https://kkmon.net/downloadpage/'
          : `https://${subDomain}.kkpoker.net/downloadpage`
      } else {
        link = 'https://kkpoker.co/'
      }
      }

      // }
      if (isAndroid || isIOS) {
        window.location.href = link
      } else {
        window.open(link, '_blank')
      }
    },
    showCodeDialog () {
      if (
        this.register_load ||
        !this.toValid('username') ||
        !this.toValid('password') ||
        !this.toValid('agreement')
      ) {
        return
      }
      this.showCode = true
    },
    toRegister () {
      const specialStr = this.isOlakk ? ' Special' : ''
      const deviceStr = window.innerWidth > 768 ? 'PC' : 'Mobile'
      this.$gtag.event('Click', {
        event_category: `SignUp${specialStr} ${deviceStr}`,
        event_label: 'Register'
      })
      if (
        this.register_load ||
        !this.toValid('username') ||
        !this.toValid('password') ||
        !this.toValid('agreement')
      ) {
        return
      }
      checkFingerprint({
        id: this.$store.state.fingerprint
      }).then((res) => {
        const buryType = !this.is_invitecode
          ? 'LinkRegister'
          : 'InviteLinkRegister'
        const f3 = !this.is_invitecode ? 1 : 2
        const f5 = res.code === 0 ? 0 : 1
        if (buryType === 'InviteLinkRegister') {
          toBury (
            this,
            buryType,
            801,
            2,
            f3,
            this.user_id,
            f5,
            this.platform,
            this.club_id
          )
        } else {
          toBury (this, buryType, 801, 2, f3, 0, f5, this.platform)
        }
        if(res.code === 0) {
          if(res.flag === 0) { // no verify code
            this.code = ''
            this.captchaKey = ''
            this.showCode = false
            this.toEmailVerification(res.flag)
          } else {
            this.showCode = true
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    async toEmailVerification(flag){
      
      // if flag is not 0, need to verify code
      if(flag !== 0) {
        if(!this.toValid('code')) {
          return
        }
      }
      this.register_load = true
      const removeSpace = this.username.replace(/\s*/g, '')
      const fingerprint = JSON.parse(localStorage.getItem('fingerprintId'))
      let registerParams = {
        username: removeSpace,
        password: md5(md5(this.password)),
        os: 'h5',
        lang: this.country || this.$i18n.locale,
        invitecode:
          this.$route.params.invitecode === undefined || this.club_id === ''
            ? ''
            : this.$route.params.invitecode,
        fingerprint_id: fingerprint.data,
        is_resend: 0, // 0: first time, 1: resend
        platform_type: siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? 15 : "",
      }
      if (this.code) {
        registerParams.captcha = this.code
        registerParams.captchaKey = this.captchaKey
      }
      let mitRes = {};
      if (this.$root.currentType === 'denmark') {
        mitRes = await getMitIDLink()
        if (mitRes.code === 0) {
          registerParams.mitid_trackid = mitRes.track_id
        }
      }
      // save register params to store
      this.$store.commit('SET_REGISTER_PARAMS', registerParams)
      const params = this.$store.state.registerParams
      sendRegister(params)
      .then((res) => {
        if(res.code === 0) {
          localStorage.setItem("registerToken", res.token);
          if (this.$root.currentType === 'denmark') {
            window.location.href = mitRes.url;
          } else {
            this.refresh()
            this.$router.push({
            path: '/registerEmail',
            query: {
              lang: this.country,
              email: this.username,
              clubId: this.club_id,
              hostId: this.user_id,
              is_invitecode: this.is_invitecode,
              platform: this.$store.state.platform
            }
          })
          }
        } else {
          const msg = getErrorMsg(res.code)
          this.$toast({
            message: this.$t(msg),
            className: 'register_toast'
          })
        }
      }).catch(() => {
        this.$toast({
          message: this.$t('register.LAB_HISTORY_SHARE_ERROR'),
          className: 'register_toast'
        })
        }).finally(() => {
          this.register_load = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.register_loading {
  background-image: url('/static/img/register/btn_common_1_dis.png') !important;
  cursor: not-allowed !important;
}

.original {
  .title {
    margin-bottom: 40px;
  }

  .join {
    display: flex;
    justify-content: center;
    font-size: 0.3rem;
    color: white;
    margin-top: 0.5rem;
    margin-bottom: 0.2rem;
  }

  .photo_frame {
    background-image: url(/static/img/register/frame.png);
    width: 2.25rem;
    height: 2.25rem;
    background-repeat: no-repeat, repeat;
    background-size: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .portrait_name {
    display: flex;
    justify-content: center;
    font-size: 0.3rem;
    align-items: center;
  }
}

.title {
  margin-top: 20px;
  margin-bottom: 100px;
  text-align: center;
  color: #ffea7f;
  font-size: 28px;
  padding: 0px 50px;
}

.desktop {
  .register.special {
    .content {
      width: 7rem;
    }
  }
}


</style>

<style lang="less">
.van-overlay {
  background-color: rgba(0, 0, 0, .85) !important;
}

.code-dialog {
  color: white;

  .van-dialog__header {
    background: radial-gradient(34% 34% at 50% 0%, #595C6B 0%, rgba(89, 92, 107, 0.25) 47.81%, rgba(89, 92, 107, 0) 100%), radial-gradient(47.97% 2627% at 52.03% 0%, #474A53 0%, #303136 100%);
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);
    padding-top: 0;
    height: 90px;
    font-weight: 400;
    font-size: 34px;
    line-height: 90px;
  }

  .close-btn {
    width: 70px;
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }

  .content {
    background: #2f2e32;
    padding: 10px;
  }

  .content_item {
    display: flex;
    padding: 20px;
    margin-bottom: 0 !important;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    height: 270px;
    background: #212125;
    box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.25);
  }

  .register_buttom {
    margin: 10px auto 0 !important;
    width: 360px;
    height: 90px;
    margin: 20px auto 50px auto;
    cursor: pointer;

    p {
      font-size: 28px;
      line-height: 90px;
      text-align: center;
      color: #ffffff;
    }
  }

  .code_text {
    display: block;
    margin-bottom: 10px;
    color: white;
    font-size: 25px;
  }

  .error {
    position: unset !important;

    p {
      padding: 0 !important;
    }
  }
}

.code-dialog-iom {
  background-image: url(/static/img/register/formback.jpg);
  background-size: 100% auto;
  background-repeat: no-repeat;

  .register_buttom {
    background-image: url('/static/img/register/btn_common_1_n.png');
    background-repeat: no-repeat;
    background-size: 100% auto;
  }
}

.code-dialog-nuts {
  .register_buttom {
    border: 1.5px solid;
    border-image-source: linear-gradient(0deg, #EFD5AC, #EFD5AC),
    radial-gradient(127.2% 100% at 50% 0%, #FFF7E1 0%, rgba(255, 247, 225, 0.476611) 52.45%, rgba(255, 247, 225, 0) 100%);
    background: linear-gradient(360deg, #9B8155 15%, #CBAF7E 55.5%, #F3E8A8 100%),
    linear-gradient(157.88deg, rgba(255, 255, 255, 0.8) -3.55%, rgba(255, 255, 255, 0) 49.43%);
    border-radius: 10px;
  }
}

.register-form {
  .content {
  position: relative;
  padding: 0px 40px;
  background-image: url('/static/img/register/formback.jpg');
  background-size: 100% auto;
  background-position: center -124px;
  background-repeat: no-repeat;

  .van-cell {
    background-color:#28282B;
    input {
      color: #ffffff;
    }
  }
  .custom-input-usr,
  .custom-input-psd {
    border: 2px solid #434349;
    &.not-empty {
      border: 2px solid #1D785A;
      caret-color: #1D785A;
    }
  }

  .van-cell:not(:last-child)::after {
    border-color: #686868;
    left: 0px;
  }

  .van-checkbox {
    padding: 0rem 0rem;
    margin-bottom: 50px;

    &.showTip {
      margin-top: 1.5rem !important;
    }

    .van-checkbox__icon {
      font-size: 50px;
    }

    .img-icon {
      width: 50px;
      height: 50px;
      display: inline-block;
    }

    .van-checkbox__label {
      margin-left: 4px;

      p {
        color: #666666;
        font-size: 22px;
        line-height: 34px;

        a {
          color: #666666;
          font-size: 22px;
          line-height: 34px;
          text-decoration: underline !important;
          //box-shadow: 0 1px;
        }
      }
    }
  }

  .content_item {
    position: relative;
    margin-bottom: 50px;

    .van-field__control {
      font-size: 28px;
    }

    .password_img {
      position: absolute;
      display: block;
      width: 44px;
      height: 44px;
      right: 20px;
      top: 0.26rem;
      cursor: pointer;
    }

    .error {
      position: absolute;
      width: 100%;
      height: 50px;
      left: 0px;
      top: 100%;

      p {
        color: #ff6666;
        font-size: 24px;
        line-height: 30px;
        margin-top: 6px;
        // padding: 0px;
        padding: 0rem 0.426667rem;
      }
    }
  }

  .content_pwd {
    .van-field__control {
      padding-right: 40px;
    }
  }

  .register_buttom {
    width: 360px;
    height: 90px;
    background-image: url('/static/img/register/btn_common_1_n.png');
    background-repeat: no-repeat;
    background-size: 100% auto;

    margin: 20px auto 50px auto;
    cursor: pointer;

    p {
      font-size: 28px;
      line-height: 90px;
      text-align: center;
      color: #ffffff;
    }
  }
}
}

.code_block {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  .code_img {
    display: block;
    height: 70px;
    cursor: pointer;
    margin-right: 20px;
  }

  .van-cell {
    padding: 10px 20px;
    border: 1px solid #686868;
    background-color:#28282B;
    input {
      color: #ffffff;
    }
  }

  .van-cell:not(:last-child)::after {
    border-color: #686868;
    left: 0px;
  }
}

.register-form-nuts {
  .content {
  position: relative;
  padding: 0px 40px;

  .van-cell {
    background-color:#28282B;
    input {
      color: #ffffff;
    }
  }
  .custom-input-usr,
  .custom-input-psd {
    border: 2px solid #434349;
    &.not-empty {
      border: 2px solid #78591D;
      caret-color: #78591D;
    }
  }

  .van-cell:not(:last-child)::after {
    border-color: #686868;
    left: 0px;
  }

  .van-checkbox {
    padding: 0rem 0rem;
    margin-bottom: 50px;

    &.showTip {
      margin-top: 1.5rem !important;
    }

    .van-checkbox__icon {
      font-size: 50px;
    }

    .img-icon {
      width: 50px;
      height: 50px;
      display: inline-block;
    }

    .van-checkbox__label {
      margin-left: 4px;

      p {
        color: #666666;
        font-size: 22px;
        line-height: 34px;

        a {
          color: #666666;
          font-size: 22px;
          line-height: 34px;
          text-decoration: underline !important;
          //box-shadow: 0 1px;
        }
      }
    }
  }

  .content_item {
    position: relative;
    margin-bottom: 50px;

    .van-field__control {
      font-size: 28px;
    }

    .password_img {
      position: absolute;
      display: block;
      width: 44px;
      height: 44px;
      right: 20px;
      top: 0.26rem;
      cursor: pointer;
    }

    .error {
      position: absolute;
      width: 100%;
      height: 50px;
      left: 0px;
      top: 100%;

      p {
        color: #ff6666;
        font-size: 24px;
        line-height: 30px;
        margin-top: 6px;
        // padding: 0px;
        padding: 0rem 0.426667rem;
      }
    }
  }

  .content_pwd {
    .van-field__control {
      padding-right: 40px;
    }
  }

  .register_buttom {
    width: 360px;
    height: 90px;
    border: 1.5px solid;
    border-image-source: linear-gradient(0deg, #EFD5AC, #EFD5AC),
    radial-gradient(127.2% 100% at 50% 0%, #FFF7E1 0%, rgba(255, 247, 225, 0.476611) 52.45%, rgba(255, 247, 225, 0) 100%);
    background: linear-gradient(360deg, #9B8155 15%, #CBAF7E 55.5%, #F3E8A8 100%),
    linear-gradient(157.88deg, rgba(255, 255, 255, 0.8) -3.55%, rgba(255, 255, 255, 0) 49.43%);
    border-radius: 10px;

    margin: 20px auto 50px auto;
    cursor: pointer;

    p {
      font-size: 28px;
      line-height: 90px;
      text-align: center;
      color: #ffffff;
    }
  }
}
}
</style>
